export const tr = {
    'banner-id': '№ {id}'
};
